var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column"},_vm._l((_vm.results),function(item){return _c('git-config-importer',{key:item.name,attrs:{"data":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }